import HTML from './asset/HTML.png';
import CSS from './asset/CSS.png';
import Figma from './asset/Figma.png';
import github from './asset/github.png';
import JavaScript from './asset/JavaScript.png';
import reactJS from './asset/React-JS.png';
import TailwindCSS from './asset/TailwindCSS.png';
import sass from './asset/scss.png';
import React from 'react';

import image1 from './asset/1.png';
import image2 from './asset/2.png';
import image3 from './asset/3.png';
import image4 from './asset/4.png';

export const SkillData = [
    {
        image: HTML,
        title: 'HTML',
    },
    {
        image: CSS,
        title: 'CSS',
    },
    {
        image: Figma,
        title: 'Figma',
    },
    {
        image: github,
        title: 'Github',
    },
    {
        image: JavaScript,
        title: 'JavaScript',
    },
    {
        image: reactJS,
        title: 'React js',
    },
    {
        image: TailwindCSS,
        title: 'Tailwind CSS',
    },
    {
        image: sass,
        title: 'SASS',
    }
];

export const Example = {
    Button1:
    {
        title: 'MBA (Master\'s in Business Administration)',
        year: '2020-2022',
        description: "I completed my MBA from Kunwar Satya Veera College of Engineering & Management, Bijnor between 2020 and 2022. This program equipped me with advanced knowledge and skills in business management, strategic planning, and leadership, preparing me to excel in a competitive corporate environment. I have a master\'s degree approved by AICTE & affiliated to Dr. APJ Abdul Kalam Technical University, Lucknow."
    },
    Button2:
    {
        title: 'B.Tech. (Bachelor of Technology)',
        year: '2016-2020',
        description: "I earned my B.Tech degree in Computer Science and Engineering from Kunwar Satya Veera College of Engineering & Management, Bijnor during the period of 2016 to 2020. This technical education provided me with a strong foundation in [specific skills or knowledge relevant to your field], enhancing my problem-solving abilities and analytical skills. I have a degree approved by AICTE & affiliated to Dr. APJ Abdul Kalam Technical University, Lucknow."
    },
    Button3:
    {
        title: 'Web Developer',
        company: 'Adaan Digital Solution Pvt. Ltd',
        year: 'Feb-2020 to June-2024',
        li1: "I have more than 4 Years of experience in Web Design which I have upgraded to Front-End Web Developer & where I have been active for the past 2 Months. My speciality is developing easy-to-use & graphical UI beside a base course in HTML & CSS with JavaScript to make website that are responsive & functional.",
        li2: 'Collaborated closely with clients to understand their branding, objectives, & user experience goals, resulting in a highly client satisfaction rate.',
        li3: 'Utilized industry-standard design using the basic skills like HTML & CSS with JS & React js'
    }
}

export const Study = [
    {
        title: 'MBA (IT)',
        description: 'I completed my MBA from Kunwar Satya Veera College of Engineering & Management, Bijnor between 2020 and 2022. This program equipped me with advanced knowledge and skills in business management, strategic planning, and leadership, preparing me to excel in a competitive corporate environment. I have a master\'s degree approved by AICTE & affiliated to Dr. APJ Abdul Kalam Technical University, Lucknow.',
        year: '2020 - 2022',
        college: 'Kunwar Satya Veera College of Engineering & Management, Bijnor',
        university: 'Dr. APJ Abdul Kalam Technical University, Lucknow'
    },
    {
        title: 'B.Tech. (CSE)',
        description: 'I earned my B.Tech degree in Computer Science and Engineering from Kunwar Satya Veera College of Engineering & Management, Bijnor during the period of 2016 to 2020. This technical education provided me with a strong foundation in [specific skills or knowledge relevant to your field], enhancing my problem-solving abilities and analytical skills. I have a degree approved by AICTE & affiliated to Dr. APJ Abdul Kalam Technical University, Lucknow.',
        year: '2016 - 2020',
        college: 'Kunwar Satya Veera College of Engineering & Management, Bijnor',
        university: 'Dr. APJ Abdul Kalam Technical University, Lucknow'
    }
];

export const USPdata = [
    {
        image: image1,
        num: '1',
        title: 'Level-headed',
        description: 'Maintain a calm and rational approach to problem-solving, ensuring effective design solutions.'
    },

    {
        image: image2,
        num: '2',
        title: 'Persistent',
        description: 'Dedicated to achieving exceptional design outcomes through rigorous iteration and refinement.'
    },

    {
        image: image3,
        num: '3',
        title: 'Amicable',
        description: 'Build strong client relationships through open communication and collaboration.'
    },

    {
        image: image4,
        num: '4',
        title: 'Adaptable',
        description: 'Flexible and responsive to changing project requirements and client feedback.'
    }

];